@use '../../style/functions.scss';
@use '../../style/variables.scss';
@use '../../style/mixins.scss';

$tab-active-outer-edge-curve-size: functions.pxToRem(10);

:host {
    display: block;
}

.tab-panel {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.tab-bar {
    display: flex;
    padding: functions.pxToRem(3) functions.pxToRem(16) 0 functions.pxToRem(16);
    overflow-y: auto;

    .tab {
        span {
            @include mixins.truncate-text;
            display: inline-block;
            width: 100%;
            padding: functions.pxToRem(2) 0;
        }
        transition: background-color 0.2s ease;
        cursor: pointer;

        position: relative;
        display: inline-block;
        padding: functions.pxToRem(8) functions.pxToRem(16);
        text-align: center;
        line-height: functions.pxToRem(15);
        color: rgb(var(--kompendium-contrast-1000));
        font-size: functions.pxToRem(16);
        border-radius: functions.pxToRem(8) functions.pxToRem(8) 0 0;
        margin: 0 functions.pxToRem(2);
        min-width: functions.pxToRem(
            60
        ); // needs to be here for titles to truncate

        &:before,
        &:after {
            transition: background-color 0.2s ease;

            content: '';
            display: block;
            width: $tab-active-outer-edge-curve-size;
            height: $tab-active-outer-edge-curve-size;
            position: absolute;
            bottom: 0;
            -webkit-mask-image: url("data:image/svg+xml; utf8, <svg xmlns='http://www.w3.org/2000/svg' fill-rule='evenodd' stroke-linejoin='round' stroke-miterlimit='2' clip-rule='evenodd' viewBox='0 0 50 50'><defs/><path d='M0 0c0 27.594 22.406 50 50 50H0V0z'/></svg>"); //For chrome and Safari the browser prefix is needed. (last checked Apr 2020)
            mask-image: url("data:image/svg+xml; utf8, <svg xmlns='http://www.w3.org/2000/svg' fill-rule='evenodd' stroke-linejoin='round' stroke-miterlimit='2' clip-rule='evenodd' viewBox='0 0 50 50'><defs/><path d='M0 0c0 27.594 22.406 50 50 50H0V0z'/></svg>");

            background: transparent;
        }

        &:before {
            left: -$tab-active-outer-edge-curve-size;
            transform: rotateY(180deg);
        }
        &:after {
            right: -$tab-active-outer-edge-curve-size;
        }

        &:hover {
            background-color: rgb(var(--kompendium-contrast-100));

            &:before,
            &:after {
                background-color: rgb(var(--kompendium-contrast-100));
            }
        }

        &.active {
            z-index: 1;
            color: rgb(var(--kompendium-contrast-1100));
            background: rgb(var(--kompendium-color-code-background));

            &:before,
            &:after {
                background: rgb(var(--kompendium-color-code-background));
            }
        }
    }
}

.tab-items {
    display: flex;
    max-height: functions.pxToRem(500);

    .tab-item {
        width: 100%;
        display: none;

        &.active {
            display: flex;
        }

        // &:nth-child(1) {
        //   flex-direction: column;
        // }
    }
}

kompendium-code {
    display: block;

    &:before,
    &:after {
        content: '';
        z-index: 1;
        display: block;
        position: absolute;
        left: 0;
        right: 0;
        border-radius: functions.pxToRem(9);
        pointer-events: none;
    }

    &:before {
        top: functions.pxToRem(39);
        height: functions.pxToRem(24);
        background-image: linear-gradient(
            rgb(var(--kompendium-color-code-background)),
            rgba(var(--kompendium-color-code-background), 0)
        );
    }
    &:after {
        bottom: 0;
        height: functions.pxToRem(32);
        background-image: linear-gradient(
            rgba(var(--kompendium-color-code-background), 0),
            rgb(var(--kompendium-color-code-background))
        );
    }
}

section.example {
    transition: border-color 0.3s ease 0.05s;
    padding-bottom: functions.pxToRem(40);
    margin-bottom: functions.pxToRem(40);
    border-bottom: 1px solid rgb(var(--kompendium-contrast-500));

    .result,
    .code {
        box-sizing: border-box;
        display: inline-block;
        vertical-align: top;
        width: 50%;
    }

    .result {
        padding-right: functions.pxToRem(40);

        kompendium-markdown {
            margin-bottom: functions.pxToRem(32);
        }
    }

    .code {
        position: sticky;
        top: 0;
    }
}

@media (max-width: variables.$break-point-small) {
    section.example {
        .result,
        .code {
            width: 100%;
            padding-right: 0;
            margin-bottom: functions.pxToRem(80);
        }

        .code {
            position: relative;
            margin-bottom: functions.pxToRem(40);
        }
    }
}

.show-case_description {
    padding: functions.pxToRem(12);
}

.show-case_component {
    font-family: var(--kompendium-example-font-family, inherit);
    font-size: var(--kompendium-example-font-size, inherit);
    line-height: var(--kompendium-example-line-height, inherit);
    color: var(--kompendium-example-color, inherit);

    padding: functions.pxToRem(20);
    border-radius: functions.pxToRem(14);
    background-color: rgb(var(--kompendium-contrast-100));
    border: 1px solid rgb(var(--kompendium-contrast-300));
    box-shadow: var(--shadow-showcase);
}

.debug {
    display: flex;
    justify-content: flex-end;

    a.debug-link {
        @include mixins.is-flat-clickable();
        transition:
            background-color 0.2s ease,
            box-shadow 0.2s ease,
            transform 0.1s ease-out,
            opacity 0.2s ease;

        width: functions.pxToRem(28);
        height: functions.pxToRem(28);
        font-size: 0;
        margin: functions.pxToRem(-52) functions.pxToRem(-16) 0 0;
        border-radius: 50%;

        color: rgb(var(--kompendium-contrast-1200));

        opacity: 0.6;

        &:hover {
            opacity: 1;
            background-color: rgb(var(--kompendium-contrast-100));
        }
    }
}
